import { render, staticRenderFns } from "./AddAndEditStoreSplit.vue?vue&type=template&id=8608efbe&scoped=true&"
import script from "./AddAndEditStoreSplit.vue?vue&type=script&lang=ts&"
export * from "./AddAndEditStoreSplit.vue?vue&type=script&lang=ts&"
import style0 from "./AddAndEditStoreSplit.vue?vue&type=style&index=0&id=8608efbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8608efbe",
  null
  
)

export default component.exports